var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 57,
    viewBox: "0 0 58 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.60714 3.5625C3.23549 3.5625 0.5 5.95605 0.5 8.90625V48.0938C0.5 51.0439 3.23549 53.4375 6.60714 53.4375H51.3929C54.7645 53.4375 57.5 51.0439 57.5 48.0938V8.90625C57.5 5.95605 54.7645 3.5625 51.3929 3.5625H6.60714ZM19.1879 18.3952C21.6862 18.3952 23.9059 19.151 25.5404 20.2845C27.052 21.3368 27.7599 22.3894 28.3775 23.3342L24.0614 25.2211C23.7526 24.6015 23.381 23.9534 22.4269 23.2526C21.3775 22.5231 20.3304 22.308 19.4339 22.308C15.919 22.308 14.0685 25.1684 14.0685 28.3517C14.0685 32.5346 16.5064 34.6106 19.4339 34.6106C22.2712 34.6106 23.4135 32.8839 24.1517 31.7789L28.4402 33.6946C27.6367 34.7996 26.8658 35.8805 25.1385 36.9308C24.2145 37.4974 22.0879 38.6048 19.065 38.6048C13.2978 38.6048 8.64286 34.9359 8.64286 28.4855C8.64286 22.8483 13.0216 18.3951 19.1879 18.3951V18.3952ZM28.7917 18.9883H34.5891L39.0908 32.5345L43.5598 18.9883H49.3571L41.8022 38.0379H36.2535L28.7917 18.9885V18.9883Z",
    fill: "#212121"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/cv.db4b47080a7ff99f035f61293af02a53.svg";
export { ForwardRef as ReactComponent };